/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import useBreakpointUp from "@qlik/qlik/src/hooks/useBreakpointUp";
import breakpoints from "@qlik/qlik/src/lib/breakpoints";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import CustomerCardSliderDekstop from "./CustomerCardSliderDekstop";
import CustomerCardSliderMobile from "./CustomerCardSliderMobile";

const CustomerCardSlider = ({
    data: { title, cardItems: cards, backgroundColor, additionalConfiguration, customId },
}) => {
    // Check if the device is a large device
    const largeDevice = useBreakpointUp(breakpoints.lg);
    const { sectionColorMapping } = getColorClassName(backgroundColor);
    const spacingClassName = getSpacingClassName(additionalConfiguration, "pt-15 pb-14 md:py-20 lg:py-30");
    return (
        <section
            className={`overflow-hidden ${spacingClassName} ${sectionColorMapping?.bgColor || "bg-supreme-pontiff"}`}
            id={customId}
        >
            <div className="container mb-15 lg:mb-20">
                <h2 className="md:text-center whitespace-pre-wrap">{title}</h2>
            </div>
            {/* Render for non-large devices */}
            {!largeDevice && <CustomerCardSliderMobile cards={cards} />}
            {/* Render for large devices */}
            {largeDevice && <CustomerCardSliderDekstop cards={cards} />}
        </section>
    );
};

export default CustomerCardSlider;
